// Events sent from client to server
export enum ESocketAction {
    UPDATE = 'update',
    AUTHENTICATE = 'authenticate',
    JOIN_ROOM = 'join-room',
    LEAVE_ROOM = 'leave-room'
}
